export default __webpack_public_path__ + "static/OpenSans-ExtraBold-0a6577634617c9df782a74714286c4f9.woff";